let compareList = JSON.parse(localStorage.getItem("compareList")) || [];
let productPreviews = document.querySelector(".product-previews");
let techSpecs = document.querySelector(".tech-specs");

// #region Fetchers
const fetchCollectionProducts = async (collectionId) => {
  const shopifyCollectionUrl = `https://${window.location.hostname}/collections/${collectionId}/products.json`;
  try {
    // console.log("🚀 ~ fetchProductData ~ shopifyMetaUrl:", shopifyMetaUrl);
    const response = await fetch(shopifyCollectionUrl);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const techSpec = await response.json();
    return techSpec.products;
  } catch (error) {
    console.error("Error fetching product data:", error);
  }
};

const fetchAllProducts = async (page = 1, products_array = []) => {
  return new Promise((resolve, reject) => {
    fetch(`/products.json?limit=50&page=${page}`)
      .then((r) => {
        r.json()
          .then((data) => {
            const products = data.products;
            // console.log(`Number of products fetched: ${products.length}`);

            products.forEach((product) => {
              products_array.push(product);
            });

            if (products.length === 50) {
              fetchAllProducts(page + 1, products_array)
                .then(resolve)
                .catch(reject);
            } else {
              resolve(products_array);
            }
          })
          .catch(reject);
      })
      .catch(reject);
  });
};

const fetchTechSpec = async (handle) => {
  const shopifyMetaUrl = `https://${window.location.hostname}/products/${handle}?view=expose-metafield-techspec`;

  try {
    // console.log("🚀 ~ fetchProductData ~ shopifyMetaUrl:", shopifyMetaUrl);
    const response = await fetch(shopifyMetaUrl);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const techSpec = await response.json();
    return techSpec;
  } catch (error) {
    // console.log("🚀 ~ fetchTechSpec ~ shopifyMetaUrl:", shopifyMetaUrl);
    console.error("Error fetching product data:", error);
  }
};

const fetchAllTechSpecs = async () => {
  let productArray = [];
  for (const handle of compareList) {
    // If productArray is larger than 3, break
    if (productArray.length >= 3) {
      break;
    }

    const metaDataResponse = await fetchTechSpec(handle);

    // TODO
    // if (!metaDataResponse.product_specification) {
    //   console.error("No meta data found for product:", handle);
    //   continue;
    // }

    productArray.push(metaDataResponse);
  }
  // console.log("🚀 ~ fetchAllTechSpecs ~ productArray", productArray);
  return productArray;
};

// #endregion

// #region Parsing

const groupByVendors = (products) => {
  let productGroups = {};
  for (const product of products) {
    if (!(product.vendor in productGroups)) {
      productGroups[product.vendor] = [];
    }
    productGroups[product.vendor].push(product);
  }

  // Sort vendors alphabetically
  const sortedVendors = Object.keys(productGroups).sort();

  // Create a new sorted productGroups object
  let sortedProductGroups = {};
  for (const vendor of sortedVendors) {
    // Sort products alphabetically within each vendor
    sortedProductGroups[vendor] = productGroups[vendor].sort((a, b) =>
      a.title.localeCompare(b.title)
    );
  }

  productGroups = sortedProductGroups;

  return productGroups;
};

const generateSelectOptions = (productGroups) => {
  let selectElements = document.querySelectorAll(".product-select");

  // Clear select elements
  selectElements.forEach((selectElement) => {
    selectElement.innerHTML = "";
  });

  // Count all products in productGroups
  let totalProducts = 0;
  for (const vendor in productGroups) {
    totalProducts += productGroups[vendor].length;
  }

  // Generate a list of numbers from 0 to totalProducts - 1
  let numberList = Array.from({ length: totalProducts }, (_, i) => i);

  // Generate options for each select element
  for (const [index, selectElement] of selectElements.entries()) {
    for (const vendor in productGroups) {
      let optionGroup = document.createElement("optgroup");
      optionGroup.label = vendor;
      for (const product of productGroups[vendor]) {
        let option = document.createElement("option");
        option.value = product.handle;
        option.textContent = product.title;
        optionGroup.appendChild(option);
        selectElement.appendChild(optionGroup);
      }
    }

    let rng_index = Math.floor(Math.random() * numberList.length);
    let idx = numberList[rng_index];
    numberList.splice(rng_index, 1);

    selectElement.value = selectElement.options[idx].value;
  }

  // Fire off a change event for each select element
  selectElements.forEach((selectElement) => {
    let event = new Event("change");
    selectElement.dispatchEvent(event);
  });
};

const renderProductSpecs = async () => {
  let productSelectors = document.querySelectorAll(".product-select");
  let productHandles = Array.from(productSelectors).map(
    (element) => element.value
  );

  let productDataArray = [];
  for (const handle of productHandles) {
    let productData = await fetchTechSpec(handle);
    productDataArray.push(productData);
  }

  // #region Create Data Structure of Tech Specs
  let specGroups = {};
  let productPreviews = document.querySelectorAll("comparison-instance");
  // Loop over products
  productDataArray.forEach((product, index) => {
    // Get tech specs
    const techSpecs = product.product_specification;
    
    if (!techSpecs) {
      productPreviews[index].querySelector(
        ".warning-missing-techspec"
      ).style.display = "flex";
    } else {
      productPreviews[index].querySelector(
        ".warning-missing-techspec"
      ).style.display = "none";
    }

    // Loop over keys
    for (const specGroup in techSpecs) {
      let specs = techSpecs[specGroup];
      // If specGroup doesn't exist, create it
      if (!(specGroup in specGroups)) {
        specGroups[specGroup] = {};
      }

      // Loop over specs
      for (const spec in specs) {
        if (!(spec in specGroups[specGroup])) {
          specGroups[specGroup][spec] = {};
        }
        // Add product spec to specGroup
        specGroups[specGroup][spec][index] = specs[spec];
      }
    }
  });
  // #endregion

  // #region Render Tech Specs
  let comparisonWrapper = document.querySelector(".comparison-wrapper");
  comparisonWrapper.innerHTML = "";
  let specGroupTemplate = document.querySelector("#spec-group-template");
  let specItemTemplate = document.querySelector("#spec-item-template");

  for (const specGroup in specGroups) {
    let specGroupClone = specGroupTemplate.content.cloneNode(true);
    specGroupClone.querySelector(".spec-group-title").textContent = specGroup;

    let specs = specGroups[specGroup];
    let specGroupData = specGroupClone.querySelector(".spec-group-data");

    for (const spec in specs) {
      let specItemClone = specItemTemplate.content.cloneNode(true);
      let row = specItemClone.querySelector(".row");

      for (let i = 0; i < 3; i++) {
        row.innerHTML += `<div class="column"><span class="tech-field">${spec}</span><span class="tech-value">${
          specs[spec][i] || "-"
        }</span></div>`;
      }

      // for (const [index, value] of Object.entries(specs[spec])) {
      //   row.innerHTML += `<div class="column"><span class="tech-field">${spec}</span><span class="tech-value">${value}</span></div>`;
      // }
      specGroupData.appendChild(specItemClone);
    }
    comparisonWrapper.appendChild(specGroupClone);
  }

  // #endregion
};

// #endregion

// #region HTML Elements
if (!customElements.get("product-type-select")) {
  class ProductTypeSelect extends HTMLElement {
    constructor() {
      super();
    }

    getType(element) {
      return element.getAttribute("value");
    }

    getSelectedType() {
      return this.getSelectedElement().getAttribute("value");
    }

    getSelectedElement() {
      return this.all_types_elements.find((element) =>
        element.checked ? element : null
      );
    }

    async updateProductSelects(value) {
      let products_data;
      if (!value) {
        products_data = await fetchAllProducts();
      } else {
        products_data = await fetchCollectionProducts(value);
      }

      let productGroups = groupByVendors(products_data);
      generateSelectOptions(productGroups);
    }

    async radioChange(event) {
      if (event.target.checked) {
        await this.updateProductSelects(event.target.value);
      }
    }

    async onload(product) {
      find: {
        for (const element of this.all_types_elements) {
          let collectionId = element.getAttribute("value");
          if (!collectionId) {
            // Skip empty values
            continue;
          }

          let products_data = await fetchCollectionProducts(collectionId);

          if (products_data.some((p) => p.handle === product)) {
            element.checked = true;
            await this.updateProductSelects(collectionId);
            let selectElements = document.querySelectorAll(".product-select");
            selectElements[0].value = product;
            break find;
          }
        } //Else
        await this.updateProductSelects(this.getSelectedType());
      }
    }

    setupItems() {
      this.all_types_elements = Array.from(this.querySelectorAll("input"));

      this.all_types_elements.forEach((element) => {
        element.addEventListener("change", this.radioChange.bind(this));
      });

      if (compareList.length > 0) {
        let firstItem = compareList[0];
        this.onload(firstItem);
        localStorage.setItem("compareList", JSON.stringify([]));
      } else {
        this.updateProductSelects(this.getSelectedType());
      }
    }

    connectedCallback() {
      this.setupItems();
    }
  }
  customElements.define("product-type-select", ProductTypeSelect);
}

if (!customElements.get("comparison-instance")) {
  class ComparisonInstance extends HTMLElement {
    constructor() {
      super();
      this.id_idx = this.getAttribute("index");
    }

    renderProductPreview = (productData) => {
      // Render product data to the DOM
      let element_image = this.querySelector(".product-image");
      // let element_vendor = this.querySelector(".product-vendor");
      let element_price = this.querySelector(".price");
      let element_price_before = this.querySelector(".price-before");
      let element_discount = this.querySelector(".discount");
      let element_url = this.querySelector(".product-link");
      let element_new_tag = this.querySelector(".new-tag");

      if (productData.savings && productData.savings.trim() !== "") {
        element_price_before.innerHTML = productData.retail_price;
        element_discount.innerHTML = productData.discount;
        element_price.classList.add('price-after')
      } else {
        element_price_before.innerHTML = "";
        element_discount.innerHTML = "";
        element_price.classList.remove('price-after')
      }

      if (productData.new_tag) {
        element_new_tag.style.display = "flex";
      }
      else {
        element_new_tag.style.display = "none";
      }
      element_image.src = productData.featured_image;
      // element_vendor.innerHTML = productData.vendor;
      element_price.innerHTML = productData.price;
      element_url.href = productData.url;
    };

    renderProduct = async (productHandle) => {
      try {
        const productData = await fetchTechSpec(productHandle);
        if (!productData) {
          console.error("No product data found for handle:", productHandle);
          return;
        }

        // Render product data to the DOM
        this.renderProductPreview(productData);
        await renderProductSpecs();
      } catch (error) {
        console.error("Error rendering product:", error);
      }
    };

    async onChange(event) {
      let productHandle = event.target.value;

      // Update compareList
      // let productIndex = compareList.indexOf(productHandle);
      // if (productIndex === -1) {
      //   compareList.push(productHandle);
      // } else {
      //   compareList.splice(productIndex, 1);
      // }
      // localStorage.setItem("compareList", JSON.stringify(compareList));

      // Render products
      // #region Renderers
      await this.renderProduct(productHandle);
    }

    setupItems() {
      this.productSelector = document.querySelector(
        "#product-select-" + this.id_idx
      );
      this.productSelector.addEventListener("change", this.onChange.bind(this));
    }

    connectedCallback() {
      this.setupItems();
    }
  }
  customElements.define("comparison-instance", ComparisonInstance);
}

// #endregion
